// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__25D4v","balanceDisclaimer":"posDashboard_balanceDisclaimer__1erzD"};